import React from 'react';
import { handleCheckout } from '../utils/checkout';
type CTAButtonProps = {
  label: string;
  mobileLabel?: string;
  className?: string;
};
export function CTAButton({
  label,
  mobileLabel,
  className = ''
}: CTAButtonProps) {
  return <button type="button" onClick={handleCheckout} className={`w-full md:w-auto inline-flex items-center justify-center whitespace-nowrap bg-terracotta-deep hover:bg-terracotta-ink text-ivory font-sans font-bold text-[15px] md:text-lg py-4 px-6 md:px-10 rounded-full shadow-cta transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta-deep ${className}`} data-id="element-53" data-mp="2l098ikg21u1n">
      {mobileLabel ? <>
          <span className="md:hidden" data-id="element-54" data-mp="3cpkp9r05k7oy">{mobileLabel}</span>
          <span className="hidden md:inline" data-id="element-55" data-mp="3cq3ymjbqlnrd">{label}</span>
        </> : label}
    </button>;
}